/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Champ crm
 * API description dev
 * OpenAPI spec version: 1.0
 */
import { z as zod } from "zod";

/**
 * @summary Получение истории по рекламе
 */
export const advertisementControllerGetAdvertisementHistoryParams = zod.object({
  productId: zod.number(),
});

export const advertisementControllerGetAdvertisementHistoryQueryParams = zod.object({
  periodEnd: zod.string().optional(),
  periodStart: zod.string().optional(),
});

export const advertisementControllerGetAdvertisementHistoryResponse = zod.object({
  history: zod.array(
    zod.object({
      company: zod.enum([
        "BANNER_BRAND",
        "BANNER_NOMENCLATURE",
        "CAROUSEL_BRAND",
        "CAROUSEL_NOMENCLATURE",
        "CATALOG",
        "CAROUSEL_BRAND_AUCTION",
        "SEARCH",
        "RECOMMENDATION",
        "AUTOMATIC",
        "SEARCH_CATALOG",
      ]),
      params: zod.object({
        acos: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        budget: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        balance: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        clicks: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        ctr: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        ordersFromAds: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        revenue: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        spent: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        tacos: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
        views: zod.array(
          zod.object({
            value: zod.number(),
            date: zod.string().datetime(),
          })
        ),
      }),
    })
  ),
  statistic: zod.object({
    acos: zod.number(),
    tacos: zod.number(),
    ctr: zod.number(),
    spent: zod.number(),
  }),
});

/**
 * Возвращает агрегированную статистику рекламы по всем продуктам за текущий день
 * @summary Получение дневной статистики рекламы по всем продуктам
 */
export const advertisementControllerGetDailyInnerAdStatResponse = zod.object({
  stats: zod
    .array(
      zod.object({
        sku: zod.number().describe("SKU (артикул) продукта"),
        badKeywordCount: zod.number().describe("Количество плохих ключевых слов на этот SKU"),
        recommendedKeywordCount: zod
          .number()
          .describe("Количество рекомендованных ключевых слов на этот SKU"),
        spent: zod.number().describe("Сумма потраченная на рекламу за день"),
        balance: zod.number().describe("Остаток бюджета на рекламу"),
        orders: zod.number().describe("Количество заказов с рекламы за день"),
        productName: zod.string().describe("Название продукта"),
        clicks: zod.number().describe("Количество кликов по рекламе за день"),
        views: zod.number().describe("Количество показов рекламы за день"),
        revenue: zod.number().describe("Выручка с рекламных заказов за день"),
        budget: zod.number().describe("Дневной бюджет на рекламу"),
      })
    )
    .describe("Статистика рекламы по всем продуктам за день"),
  date: zod.string().describe("Дата формирования отчета"),
});

/**
 * Возвращает отчет по ключевым словам (плохие, хорошие, рекомендованные) для указанного SKU за текущий день
 * @summary Получение ключевых слов для продукта по SKU
 */
export const advertisementControllerGetAdKeywordParams = zod.object({
  sku: zod.number().describe("SKU (артикул) продукта"),
});

export const advertisementControllerGetAdKeywordResponse = zod.object({
  badKeywords: zod.array(zod.string()).describe("Список плохих (неэффективных) ключевых слов"),
  goodKeywords: zod.array(zod.string()).describe("Список хороших (эффективных) ключевых слов"),
  recommendedKeywords: zod
    .array(
      zod.object({
        keyword: zod.string().describe("Рекомендованное ключевое слово"),
        monthly: zod.string().describe("Ежемесячный объем поисков по ключевому слову"),
        weekly: zod.string().describe("Еженедельный объем поисков по ключевому слову"),
        weeklyTrend: zod.string().describe("Тренд недельного объема поисков (%)"),
      })
    )
    .describe("Список рекомендованных ключевых слов для продукта"),
  date: zod.string().describe("Дата формирования отчета"),
  sku: zod.number().describe("SKU продукта"),
  productName: zod.string().describe("Название продукта"),
});

export const authControllerLoginBody = zod.object({
  email: zod.string(),
  password: zod.string(),
});

export const authControllerLoginResponse = zod.object({
  user: zod.object({
    id: zod.string().describe("Unique identifier of the user"),
    email: zod.string().describe("Email address of the user"),
    name: zod.string().optional().describe("First name of the user"),
    surname: zod.string().optional().describe("Last name of the user"),
    department: zod
      .enum([
        "HR",
        "PRODUCT",
        "COMMERS",
        "MARKETING",
        "FINANCE",
        "LOGISTIC",
        "ANALYTIC",
        "FATHERS",
        "NOOB",
      ])
      .describe("Department of the user"),
    role: zod
      .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
      .describe("Role of the user"),
    gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
    isActivate: zod.boolean().describe("account activate"),
  }),
  access_token: zod.string(),
});

export const authControllerLogoutResponse = zod.object({
  userId: zod.string(),
});

export const authControllerRegistrationBody = zod.object({
  email: zod.string(),
  password: zod.string(),
  name: zod.string(),
  surname: zod.string(),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
});

export const authControllerActivateAccountParams = zod.object({
  link: zod.string(),
});

/**
 * @summary Запросить ссылку для сброса пароля
 */
export const authControllerSendResetPasswordLinkBody = zod.object({
  email: zod.string().describe("Почта пользователя для которого нужно сбросить пароль"),
});

/**
 * @summary Задать новый пароль
 */
export const authControllerResetPasswordParams = zod.object({
  link: zod.string().describe("уникальный идентификатор запроса на сброс пароля"),
});

export const authControllerResetPasswordBody = zod.object({
  newPassword: zod.string(),
});

export const authControllerResetPasswordResponse = zod.object({
  status: zod.string(),
});

export const authControllerRefreshResponse = zod.object({
  user: zod.object({
    id: zod.string().describe("Unique identifier of the user"),
    email: zod.string().describe("Email address of the user"),
    name: zod.string().optional().describe("First name of the user"),
    surname: zod.string().optional().describe("Last name of the user"),
    department: zod
      .enum([
        "HR",
        "PRODUCT",
        "COMMERS",
        "MARKETING",
        "FINANCE",
        "LOGISTIC",
        "ANALYTIC",
        "FATHERS",
        "NOOB",
      ])
      .describe("Department of the user"),
    role: zod
      .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
      .describe("Role of the user"),
    gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
    isActivate: zod.boolean().describe("account activate"),
  }),
  access_token: zod.string(),
});

/**
 * @deprecated
 */
export const userControllerGetAllResponseItem = zod.object({
  id: zod.string().describe("Unique identifier of the user"),
  email: zod.string().describe("Email address of the user"),
  name: zod.string().optional().describe("First name of the user"),
  surname: zod.string().optional().describe("Last name of the user"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .describe("Department of the user"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .describe("Role of the user"),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
  isActivate: zod.boolean().describe("account activate"),
});
export const userControllerGetAllResponse = zod.array(userControllerGetAllResponseItem);

/**
 * @deprecated
 */
export const userControllerFindOneParams = zod.object({
  id: zod.string(),
});

export const userControllerFindOneResponse = zod.object({
  id: zod.string().describe("Unique identifier of the user"),
  email: zod.string().describe("Email address of the user"),
  name: zod.string().describe("First name of the user"),
  surname: zod.string().describe("Last name of the user"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .describe("Department of the user"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .describe("Role of the user"),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
  isActivate: zod.boolean().describe("account activate"),
});

/**
 * @summary Обновление сотрудника - роль, департамент ....
 */
export const userControllerUpdateParams = zod.object({
  id: zod.string(),
});

export const userControllerUpdateBody = zod.object({
  name: zod.string().optional().describe("Имя пользователя"),
  surname: zod.string().optional().describe("Фамилия пользователя"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .optional()
    .describe("Отдел пользователя"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .optional()
    .describe("Роль пользователя"),
  gender: zod.enum(["MALE", "FEMALE"]).optional().describe("Пол пользователя"),
  isActivate: zod.boolean().optional().describe("Активирован ли пользователь"),
});

export const userControllerUpdateResponse = zod.object({
  id: zod.string().describe("Unique identifier of the user"),
  email: zod.string().describe("Email address of the user"),
  name: zod.string().describe("First name of the user"),
  surname: zod.string().describe("Last name of the user"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .describe("Department of the user"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .describe("Role of the user"),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
  isActivate: zod.boolean().describe("account activate"),
});

/**
 * @deprecated
 */
export const userControllerRemoveParams = zod.object({
  id: zod.string(),
});

export const userControllerRemoveResponse = zod.object({
  id: zod.string().describe("UUID удаленного пользователя"),
  email: zod.string().describe("Email удаленного пользователя"),
  name: zod.string().describe("Имя пользователя"),
  surname: zod.string().describe("Фамилия пользователя"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .describe("Отдел пользователя"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .describe("Роль пользователя"),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Пол пользователя"),
  isActivate: zod.boolean().describe("Был ли пользователь активирован на момент удаления"),
});

/**
 * @summary Взять сотрудника в подчинение
 */
export const userControllerMakeSubordinateParams = zod.object({
  userId: zod.string(),
});

export const userControllerMakeSubordinateResponse = zod.object({
  status: zod.string(),
});

export const userControllerUpdateSelfBody = zod.object({
  name: zod.string().optional().describe("Имя пользователя"),
  surname: zod.string().optional().describe("Фамилия пользователя"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .optional()
    .describe("Отдел пользователя"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .optional()
    .describe("Роль пользователя"),
  gender: zod.enum(["MALE", "FEMALE"]).optional().describe("Пол пользователя"),
  isActivate: zod.boolean().optional().describe("Активирован ли пользователь"),
});

export const userControllerUpdateSelfResponse = zod.object({
  id: zod.string().describe("Unique identifier of the user"),
  email: zod.string().describe("Email address of the user"),
  name: zod.string().describe("First name of the user"),
  surname: zod.string().describe("Last name of the user"),
  department: zod
    .enum([
      "HR",
      "PRODUCT",
      "COMMERS",
      "MARKETING",
      "FINANCE",
      "LOGISTIC",
      "ANALYTIC",
      "FATHERS",
      "NOOB",
    ])
    .describe("Department of the user"),
  role: zod
    .enum(["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB", "DEVELOPER"])
    .describe("Role of the user"),
  gender: zod.enum(["MALE", "FEMALE"]).describe("Gender of the user"),
  isActivate: zod.boolean().describe("account activate"),
});

/**
 * @summary server-side events
 */
export const alertControllerSseResponse = zod.object({
  data: zod.object({
    productId: zod.number(),
    sku: zod.number(),
    marketplace: zod.enum(["OZON", "WB", "YM"]),
    barcode: zod.string(),
    alertKind: zod.enum([
      "INSUFFICIENT_STOCK_ON_MARKETPLACE",
      "EXCESSIVE_STOCK",
      "PINNED_COMMENT_DELETED",
      "NEGATIVE_REVIEWS_IN_THE_TOP",
      "SKLEIKA_NEGATIVE_REVIEWS_IN_THE_TOP",
      "RATING_DROP",
      "SKLEIKA_RATING_DROP",
      "LOW_RATING",
      "SKLEIKA_LOW_RATING",
      "REVIEWS_AMOUNT_DROP",
      "SKLEIKA_REVIEWS_AMOUNT_DROP",
      "CR_DROP",
      "CR_TO_SHOPPING_CART_DROP",
      "SEARCH_POSITION_DROP",
      "LOW_BUDGET",
      "TACOS_GROWTH",
      "STRONG_PRICE_CHANGE",
      "PRICE_IS_LESS_OR_EQUAL_COST_PRICE",
    ]),
    alertCategory: zod
      .enum(["AMOUNT_ALERT", "RATING_ALERT", "CONVERSION_ALERT", "ADS_ALERT", "PRICE_ALERT"])
      .describe("Категория уведомления"),
    priority: zod.number().describe("Задает значимость уведомления среди всех уведомлений"),
    priorityInCategory: zod
      .number()
      .describe(
        "Задает значимость уведомления внутри категории. Используется для выбора цвета уведомления"
      ),
    payload: zod.object({}).optional(),
  }),
  type: zod.enum([
    "INSUFFICIENT_STOCK_ON_MARKETPLACE",
    "EXCESSIVE_STOCK",
    "PINNED_COMMENT_DELETED",
    "NEGATIVE_REVIEWS_IN_THE_TOP",
    "SKLEIKA_NEGATIVE_REVIEWS_IN_THE_TOP",
    "RATING_DROP",
    "SKLEIKA_RATING_DROP",
    "LOW_RATING",
    "SKLEIKA_LOW_RATING",
    "REVIEWS_AMOUNT_DROP",
    "SKLEIKA_REVIEWS_AMOUNT_DROP",
    "CR_DROP",
    "CR_TO_SHOPPING_CART_DROP",
    "SEARCH_POSITION_DROP",
    "LOW_BUDGET",
    "TACOS_GROWTH",
    "STRONG_PRICE_CHANGE",
    "PRICE_IS_LESS_OR_EQUAL_COST_PRICE",
  ]),
  id: zod.number(),
});

/**
 * @summary Только для DAG
 */
export const logisticControllerUpdateDeliveryDataBodyItem = zod.string();
export const logisticControllerUpdateDeliveryDataBody = zod.array(
  logisticControllerUpdateDeliveryDataBodyItem
);

/**
 * @summary Получение списка портфелей
 */
export const briefcaseControllerGetBriefcasesResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
});
export const briefcaseControllerGetBriefcasesResponse = zod.array(
  briefcaseControllerGetBriefcasesResponseItem
);

/**
 * @deprecated
 */
export const productControllerRemoveParams = zod.object({
  id: zod.number(),
});

/**
 * @summary Поиск товара по sku, общему артиклю или названию
 */
export const productControllerSearchProductBody = zod.object({
  searchString: zod.string().describe("строка для поиска"),
});

/**
 * @deprecated
 */
export const productControllerSaveNewProductsBodyItem = zod.string();
export const productControllerSaveNewProductsBody = zod.array(
  productControllerSaveNewProductsBodyItem
);

/**
 * @summary Получение списка не назначенных никому продуктов
 */
export const productControllerGetUnassignedProductsResponseItem = zod.object({
  productId: zod.number(),
  sku: zod.number(),
  marketplace: zod.enum(["OZON", "WB", "YM"]),
  barcode: zod.string(),
  name: zod.string(),
  company: zod.string(),
  brand: zod.string(),
  description: zod.string(),
  url: zod.string(),
  generalArticle: zod.number(),
});
export const productControllerGetUnassignedProductsResponse = zod.array(
  productControllerGetUnassignedProductsResponseItem
);

export const categoryControllerGetAllResponseItem = zod.object({
  id: zod.number().describe("id категории"),
  name: zod.string().describe("название категории"),
});
export const categoryControllerGetAllResponse = zod.array(categoryControllerGetAllResponseItem);

/**
 * @summary Получить категории для портфелей
 */
export const categoryControllerGetOptionsQueryParams = zod.object({
  briefcaseIds: zod
    .array(zod.number())
    .optional()
    .describe("Массив id портфелей (briefcases). Если не передан - берутся все"),
});

export const categoryControllerGetOptionsResponseItem = zod.object({
  name: zod.string().describe("Название категории"),
  id: zod.number().describe("Id категории"),
});
export const categoryControllerGetOptionsResponse = zod.array(
  categoryControllerGetOptionsResponseItem
);

export const ratingControllerGetProductRatingHistoryParams = zod.object({
  productId: zod.number(),
});

export const ratingControllerGetProductRatingHistoryQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const ratingControllerGetProductRatingHistoryResponse = zod.object({
  productCardRating: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  productCardReviewsAmount: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  skleikaRating: zod.array(
    zod.object({
      value: zod.number().optional(),
      date: zod.string().datetime(),
    })
  ),
  skleikaReviewsAmount: zod.array(
    zod.object({
      value: zod.number().optional(),
      date: zod.string().datetime(),
    })
  ),
});

/**
 * @summary Назначение менеджеру продуктов
 */
export const managerAppointmentControllerAppointManagerBody = zod.object({
  managerId: zod.string().describe("Unique identifier of the user"),
  productsIds: zod.array(zod.number()).describe("Unique identifiers of the products"),
});

export const managerAppointmentControllerAppointManagerResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Добавление / удаление продукта в избранное (только назначенный продукту менеджер или босс)
 */
export const managerAppointmentControllerUpdateFavoriteParams = zod.object({
  productId: zod.any(),
});

export const managerAppointmentControllerUpdateFavoriteBody = zod.object({
  productId: zod.number(),
  isFavorite: zod.boolean(),
});

/**
 * @summary Оставить комментарий к продукту
 */
export const commentControllerCreateCommentBody = zod.object({
  comment: zod.string(),
  productId: zod.number(),
});

/**
 * @summary Получить все комментарии по продукту
 */
export const commentControllerGetCommentsForProductParams = zod.object({
  productId: zod.number().describe("Id продукта"),
});

/**
 * @summary Получение дашборда
 */
export const dashboardControllerGetDashboardParams = zod.object({
  productId: zod.number(),
});

export const dashboardControllerGetDashboardResponse = zod.object({
  plannedNetProfit: zod.number(),
  actualNetProfit: zod.number(),
  plannedOrders: zod.number(),
  actualOrders: zod.number(),
  plannedRevenue: zod.number(),
  actualRevenue: zod.number(),
  tacosHistory: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  markup: zod.number(),
  averageProfitability: zod.number(),
});

export const netProfitControllerGetNetProfitsHistoryFprProductsQueryParams = zod.object({
  periodEnd: zod.any().optional(),
});

export const netProfitControllerGetNetProfitsHistoryFprProductsBodyItem = zod.object({
  sku: zod.number(),
  marketplace: zod.string(),
});
export const netProfitControllerGetNetProfitsHistoryFprProductsBody = zod.array(
  netProfitControllerGetNetProfitsHistoryFprProductsBodyItem
);

/**
 * @summary Получение истории заказов / возвратов / refund-ов по карточке продукта
 */
export const orderHistoryControllerGetOrderHistoryForProductParams = zod.object({
  productId: zod.number(),
});

export const orderHistoryControllerGetOrderHistoryForProductQueryParams = zod.object({
  periodStart: zod.string(),
  periodEnd: zod.string(),
});

export const orderHistoryControllerGetOrderHistoryForProductResponse = zod.object({
  ordersAmount: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  ordersWithoutReturnsAmount: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  returnAmount: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  selfPurchaseAmount: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  name: zod.string().describe("Название товара"),
  image: zod.string().nullable(),
  url: zod.string().nullable().describe("Ссылка на карточку товара"),
});

/**
 * @summary Получение истории цен товара в текущем месяце
 */
export const productReportControllerGetProductPriceHistoryParams = zod.object({
  id: zod.number(),
});

export const productReportControllerGetProductPriceHistoryQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const productReportControllerGetProductPriceHistoryResponse = zod.object({
  oldPrice: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  price: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  priceWithCard: zod.array(
    zod.object({
      value: zod.number().optional(),
      date: zod.string().datetime(),
    })
  ),
  priceWithSpp: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  sppPercent: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
});

/**
 * @summary Получение сводки по карточке
 */
export const productReportControllerGetProductCardSummaryParams = zod.object({
  productId: zod.number(),
});

export const productReportControllerGetProductCardSummaryQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const productReportControllerGetProductCardSummaryResponse = zod.object({
  generalArticle: zod.number(),
  sku: zod.number(),
  marketplace: zod.enum(["OZON", "WB", "YM"]),
  name: zod.string(),
  image: zod.string().describe("Картинка-обложка для карточки"),
  additionalImages: zod.array(zod.string()).describe("Прочие картинки"),
  articleStatus: zod.enum(["Вывод", "Новый", "Неликвид", "Ликвид", "Перезапуск", "Архив"]),
  productCardStatus: zod.enum([
    "Архив",
    "не в АМ",
    "Ключевой",
    "Распродаем",
    "Запуск",
    "СТОП отгрузка!",
    "Перезапуск",
    "Для индексации цен",
    "Стратегия демпинга",
    "FBS",
    "Дешевый выкуп",
  ]),
  category: zod.string(),
  company: zod.string(),
  actualOrdersAmount: zod.number(),
  manager: zod.string(),
  nearestDeliveries: zod.array(
    zod.object({
      date: zod.string().datetime(),
      value: zod.number(),
    })
  ),
  nearestDeliveriesToMarketplace: zod.array(
    zod.object({
      date: zod.string().datetime(),
      value: zod.number(),
    })
  ),
  nearestDeliveriesToMoscow: zod.array(
    zod.object({
      date: zod.string().datetime(),
      value: zod.number(),
    })
  ),
  orders: zod.array(
    zod.object({
      date: zod.string().datetime(),
      value: zod.number(),
    })
  ),
  oldPrice: zod.number(),
  plannedNetProfitAmount: zod.number(),
  plannedOrdersAmount: zod.number(),
  plannedRevenueAmount: zod.number(),
  price: zod.number(),
  priceWithCard: zod.number(),
  priceWithSpp: zod.number(),
  costPrice: zod.number().describe("Себестоимость продукта"),
  productCardRating: zod.number(),
  productCardReviewsAmount: zod.number(),
  skleikaRating: zod.number(),
  skleikaReviewsAmount: zod.number(),
  quantityLeftOnMarketplace: zod.number(),
  quantityLeftOnMoscowWarehouse: zod.number(),
  actualNetProfitAmount: zod.number(),
  actualRevenueAmount: zod.number(),
  enoughForDays: zod.number(),
  reservedOnMarketplace: zod.number(),
  wayToMarketplace: zod.number(),
  marketingCampaigns: zod.array(zod.string()),
});

/**
 * @summary Получение сводки по карточке
 */
export const productReportControllerGetProductCardReportParams = zod.object({
  productId: zod.number(),
});

export const productReportControllerGetProductCardReportQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const productReportControllerGetProductCardReportResponse = zod.object({
  productInfo: zod.object({
    priceWithSpp: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    priceBeforeSpp: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    stock: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
  }),
  advertisingInfo: zod.object({
    acos: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    budget: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    balance: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    clicks: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    ctr: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    ordersFromAds: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    revenue: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    spent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    tacos: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    views: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
  }),
  purchaseFunnelInfo: zod.object({
    cr: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showLook: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showCard: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showCardPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    basketOrder: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    basketOrderPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    cardBasket: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    cardBasketPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    tacos: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
  }),
  profitInfo: zod.object({
    revenue: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    netProfit: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    netProfitPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    ordersWithoutReturnsAmount: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
  }),
  ratingInfo: zod.object({
    productCardRating: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    skleikaRating: zod.array(
      zod.object({
        value: zod.number().optional(),
        date: zod.string().datetime(),
      })
    ),
    productCardReviewsAmount: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    skleikaReviewsAmount: zod.array(
      zod.object({
        value: zod.number().optional(),
        date: zod.string().datetime(),
      })
    ),
  }),
});

/**
 * @summary Получение экономики по карточке
 */
export const productReportControllerGetProductCardEconomyParams = zod.object({
  productId: zod.number(),
});

export const productReportControllerGetProductCardEconomyQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const productReportControllerGetProductCardEconomyResponse = zod.object({
  markup: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  revenue: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  revenuePercent: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  netProfit: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
  netProfitPercent: zod.array(
    zod.object({
      value: zod.number(),
      date: zod.string().datetime(),
    })
  ),
});

export const productReportControllerGetPurchaseFunnelParams = zod.object({
  productId: zod.number(),
});

export const productReportControllerGetPurchaseFunnelQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const productReportControllerGetPurchaseFunnelResponse = zod.object({
  history: zod.object({
    cr: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showLook: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showCard: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    showCardPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    basketOrder: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    basketOrderPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    cardBasket: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    cardBasketPercent: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
    tacos: zod.array(
      zod.object({
        value: zod.number(),
        date: zod.string().datetime(),
      })
    ),
  }),
  stat: zod.object({
    showLook: zod.number(),
    showCard: zod.number(),
    showCardPercent: zod.number(),
    basketOrder: zod.number(),
    basketOrderPercent: zod.number(),
    cardBasket: zod.number(),
    cardBasketPercent: zod.number(),
  }),
});

/**
 * @summary Выбор логов по параметрам
 */
export const requestLoggerControllerGetQueryLimitDefault = 100;
export const requestLoggerControllerGetQueryLimitMax = 100;
export const requestLoggerControllerGetQueryPageDefault = 1;

export const requestLoggerControllerGetQueryParams = zod.object({
  limit: zod
    .number()
    .max(requestLoggerControllerGetQueryLimitMax)
    .default(requestLoggerControllerGetQueryLimitDefault)
    .describe("количество записей на странице"),
  page: zod.number().default(requestLoggerControllerGetQueryPageDefault).describe("номер страницы"),
});

export const requestLoggerControllerGetHeader = zod.object({
  "x-dag-get-key": zod.string().describe("Ключ доступа для получения логов"),
});

export const requestLoggerControllerGetResponse = zod.object({
  data: zod
    .array(
      zod.object({
        id: zod.number().describe("ID лога"),
        url: zod.string().describe("url запроса"),
        method: zod.enum(["GET", "POST", "PUT", "PATCH", "DELETE"]).describe("метод запроса"),
        createdAt: zod.string().datetime().describe("время запроса"),
        user: zod
          .object({})
          .nullable()
          .describe("Пользователь, который делал запрос. Может быть неопределен"),
      })
    )
    .describe("данные логов"),
  meta: zod
    .object({
      page: zod.number().describe("текущая страница"),
      limit: zod.number().describe("текущий размер страницы"),
      total: zod.number().describe("общее количество записей"),
      totalPages: zod.number().describe("общее количество страниц"),
    })
    .describe("данные о размере данных"),
});

/**
 * @summary Ревью за период
 */
export const reviewControllerGetInfoByBriefcaseForPeriodQueryParams = zod.object({
  dateFrom: zod.string().date(),
  dateTo: zod.string().date(),
});

export const reviewControllerGetInfoByBriefcaseForPeriodResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
  marketplaces: zod
    .array(
      zod.object({
        marketplace: zod.enum(["OZON", "WB", "YM"]),
        articles: zod
          .array(
            zod.object({
              id: zod.number(),
              name: zod.string().describe("Название товара (General Article)"),
              generalArticle: zod.number().describe("геренальный артикль"),
              briefcaseName: zod
                .string()
                .describe("Имя портфеля, к которому принадлежит General Article"),
              articleSubcategoryName: zod.string().describe("Имя субкатегории"),
              articleSubcategoryId: zod.number().describe("Id субкатегории"),
              reviewStats: zod.object({
                reviewCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Общее количество отзывов"),
                conversionInReviewCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество уникальных"),
                ordersCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество заказов"),
                positiveReviewCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество позитивных отзывов"),
                negativeReviewCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество нигативных отзывов"),
                defectReviewCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество отзывов с проблемой товара"),
                marketplaceProblemCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество отзывов с проблемой маркетплейса"),
                failureToMeetExpectationsCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество отзывов с проблемой несоответствия ожиданиям"),
                othersProblemCount: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Количество отзывов с другими проблемами"),
                rating: zod
                  .object({
                    periodValue: zod.number(),
                    previousPeriodValue: zod.number(),
                    fromPeriod: zod.array(
                      zod.object({
                        date: zod.string().date().describe("точка на графике. Делится по дням"),
                        value: zod.number().describe("значение за день"),
                      })
                    ),
                  })
                  .describe("Средний рейтинг, от 0 до 5, точность 1 знак после запятой"),
                reviewWithTextCount: zod
                  .object({
                    periodValue: zod.number(),
                  })
                  .describe("Количество отзывов с текстом"),
              }),
              status: zod.string(),
            })
          )
          .describe("Товары в определенном маркетплейсе"),
      })
    )
    .describe("Сортировка товаров по маркетплейсам"),
});
export const reviewControllerGetInfoByBriefcaseForPeriodResponse = zod.array(
  reviewControllerGetInfoByBriefcaseForPeriodResponseItem
);

/**
 * @summary Ревью за период по артиклю
 */
export const reviewControllerGetInfoByGeneralArticleQueryParams = zod.object({
  generalArticle: zod.number().describe("Главный артикль"),
  dateFrom: zod.string().date(),
  dateTo: zod.string().date(),
});

export const reviewControllerGetInfoByGeneralArticleResponse = zod.object({
  id: zod.number().describe("ID нерального артикля"),
  name: zod.string().describe("Название главного артикля"),
  generalArticle: zod.number().describe("Номер главного артикля"),
  classification: zod.array(
    zod
      .enum([
        "Нету Текста",
        "Другое",
        "Проблема Товара",
        "Позитив",
        "Проблема Мп",
        "Несоответствие Ожиданиям",
      ])
      .describe("Классификация отзывов в ответе")
  ),
  info: zod.array(
    zod.object({
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      firstReviewDate: zod.string().date().nullable().describe("Дата первого коментария"),
      aggregatedStats: zod
        .object({
          reviewCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Общее количество отзывов"),
          conversionInReviewCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество уникальных"),
          ordersCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество заказов"),
          positiveReviewCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество позитивных отзывов"),
          negativeReviewCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество нигативных отзывов"),
          defectReviewCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество отзывов с проблемой товара"),
          marketplaceProblemCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество отзывов с проблемой маркетплейса"),
          failureToMeetExpectationsCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество отзывов с проблемой несоответствия ожиданиям"),
          othersProblemCount: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Количество отзывов с другими проблемами"),
          rating: zod
            .object({
              periodValue: zod.number(),
              previousPeriodValue: zod.number(),
              fromPeriod: zod.array(
                zod.object({
                  date: zod.string().date().describe("точка на графике. Делится по дням"),
                  value: zod.number().describe("значение за день"),
                })
              ),
            })
            .describe("Средний рейтинг, от 0 до 5, точность 1 знак после запятой"),
          reviewWithTextCount: zod
            .object({
              periodValue: zod.number(),
            })
            .describe("Количество отзывов с текстом"),
        })
        .describe("Общие данные статистики по маркетплейсу"),
    })
  ),
});

/**
 * @summary Анализ комментариев
 */
export const reviewControllerGetTFIDFQueryParams = zod.object({
  generalArticle: zod.number().describe("Главный артикль"),
  dateFrom: zod.string().date(),
  dateTo: zod.string().date(),
  classification: zod
    .enum([
      "Нету Текста",
      "Другое",
      "Проблема Товара",
      "Позитив",
      "Проблема Мп",
      "Несоответствие Ожиданиям",
    ])
    .describe("Классификация отзыва (одно значение)"),
  marketplace: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений)"),
  top_n_keywords: zod.number().optional().describe("Количество ключевых слов для возврата"),
  stopwords: zod
    .array(zod.string())
    .optional()
    .describe("Список стоп-слов для исключения из анализа"),
});

export const reviewControllerGetTFIDFResponse = zod.object({
  tfidf: zod
    .array(
      zod.object({
        problem: zod.string().describe("Название проблемы из анализа"),
        value: zod.number().describe("Вес проблемы"),
      })
    )
    .describe("Результат анализа"),
  total_processed: zod.number().describe("Размер обработки"),
  commentData: zod
    .array(
      zod.object({
        rating: zod.number(),
        text: zod.string(),
        marketplace: zod.string().describe("Маркетплейс"),
        summarization: zod.string().describe("Суммаризация коммента"),
        date: zod.string().datetime().describe("Дата коммента"),
      })
    )
    .describe("Коментарии"),
});

/**
 * @summary Получение категорий и статистики по входящим в них товаров
 */
export const tableControllerGetProductsOverviewQueryParams = zod.object({
  date: zod.any().optional(),
});

export const tableControllerGetProductsOverviewResponseItem = zod.object({
  category: zod.string().describe("Название категории"),
  products: zod.array(
    zod.object({
      generalArticle: zod.number().describe("Уникальный код товара без привязки к маркетплейсу"),
      id: zod.number().describe("Первичный ключ карточки продукта"),
      sku: zod.number().describe("Уникальный номер товара на маркетплейсе"),
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      category: zod.string().describe("Категория товара"),
      name: zod.string().describe("Название товара"),
      image: zod.string(),
      url: zod.string().describe("Ссылка на карточку товара"),
      mpStatUrl: zod.string(),
      articleStatus: zod.enum(["Вывод", "Новый", "Неликвид", "Ликвид", "Перезапуск", "Архив"]),
      productCardStatus: zod.enum([
        "Архив",
        "не в АМ",
        "Ключевой",
        "Распродаем",
        "Запуск",
        "СТОП отгрузка!",
        "Перезапуск",
        "Для индексации цен",
        "Стратегия демпинга",
        "FBS",
        "Дешевый выкуп",
      ]),
      companyName: zod.string(),
      brand: zod.string().optional(),
      manager: zod.object({
        email: zod.string(),
        managerId: zod.string(),
        name: zod.string(),
        surname: zod.string(),
      }),
      isFavorite: zod.boolean().describe("Добавлен ли товар в избранное"),
      price: zod.number().describe("Цена, которую мы получаем"),
      plannedPrice: zod.number().describe("Цена, которая заложена в плане"),
      priceWithSpp: zod.number().describe("Цена, которую платит покупатель"),
      averageOrdersIn4Days: zod.number().describe("Среднее количество заказов за 4 дня"),
      dailyActualOrderAmount: zod
        .number()
        .describe("Среднее количество заказов в день в текущем месяце"),
      dailyPlannedOrderAmount: zod
        .number()
        .describe("Запланированное количество заказов за один день в этом месяце"),
      newDailyPlan: zod
        .number()
        .describe(
          "Среднее количество заказов в оставшиеся дни месяца, которое нужно чтобы суметь уложиться в план"
        ),
      quantityLeftOnMarketplace: zod
        .number()
        .describe("Количество товара, переданное маркетплейсу"),
      enoughForDays: zod
        .number()
        .describe(
          "На сколько дней хватит товара, имеющегося на маркетплейсе (если будет продаваться с той же скоростью, как последние 4 дня)"
        ),
      netProfitOnMarketplace: zod.number().describe("Чистая прибыль маркетплейса"),
      plannedProfitPercent: zod.number().describe("Запланированная чистая прибыль"),
    })
  ),
});
export const tableControllerGetProductsOverviewResponse = zod.array(
  tableControllerGetProductsOverviewResponseItem
);

/**
 * @summary Получение категорий и остатков по входящим в них товарам
 */
export const tableControllerGetRemainingProductsQueryParams = zod.object({
  periodEnd: zod.any().optional(),
});

export const tableControllerGetRemainingProductsResponseItem = zod.object({
  category: zod.string(),
  products: zod.array(
    zod.object({
      generalArticle: zod.number().describe("Уникальный код товара без привязки к маркетплейсу"),
      id: zod.number().describe("Первичный ключ карточки продукта"),
      sku: zod.number().describe("Уникальный номер товара на маркетплейсе"),
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      category: zod.string().describe("Категория товара"),
      name: zod.string().describe("Название товара"),
      image: zod.string(),
      url: zod.string().describe("Ссылка на карточку товара"),
      mpStatUrl: zod.string(),
      articleStatus: zod.enum(["Вывод", "Новый", "Неликвид", "Ликвид", "Перезапуск", "Архив"]),
      productCardStatus: zod.enum([
        "Архив",
        "не в АМ",
        "Ключевой",
        "Распродаем",
        "Запуск",
        "СТОП отгрузка!",
        "Перезапуск",
        "Для индексации цен",
        "Стратегия демпинга",
        "FBS",
        "Дешевый выкуп",
      ]),
      companyName: zod.string(),
      brand: zod.string().optional(),
      isFavorite: zod.boolean(),
      quantityLeftOnMarketplace: zod.number(),
      enoughForDays: zod
        .number()
        .describe("На сколько дней хватит (при том же темпе продаж, что за последние 4 дня)"),
      wayToMarketplace: zod.number().describe("Количество товара в пути"),
      reservedOnMarketplace: zod.number(),
      warehouseInMoscow: zod.number(),
      nearestDeliveryAmount: zod.number(),
      nearestDeliveryDate: zod.string().datetime(),
      futureDeliveries: zod.array(
        zod.object({
          amount: zod.number().describe("Количество товара в партии"),
          arrivalDate: zod.string().datetime().describe("Ориентировочное время прибытия"),
        })
      ),
      manager: zod.object({
        email: zod.string(),
        managerId: zod.string(),
        name: zod.string(),
        surname: zod.string(),
      }),
    })
  ),
});
export const tableControllerGetRemainingProductsResponse = zod.array(
  tableControllerGetRemainingProductsResponseItem
);

/**
 * @summary Получение категорий и истории заказов входящих в них продуктов
 */
export const tableControllerGetProductsOrderHistoryQueryParams = zod.object({
  periodStart: zod.string().optional(),
  periodEnd: zod.string().optional(),
});

export const tableControllerGetProductsOrderHistoryResponseItem = zod.object({
  category: zod.string(),
  products: zod.array(
    zod.object({
      generalArticle: zod.number().describe("Уникальный код товара без привязки к маркетплейсу"),
      id: zod.number().describe("Первичный ключ карточки продукта"),
      sku: zod.number().describe("Уникальный номер товара на маркетплейсе"),
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      category: zod.string().describe("Категория товара"),
      name: zod.string().describe("Название товара"),
      image: zod.string(),
      url: zod.string().describe("Ссылка на карточку товара"),
      mpStatUrl: zod.string(),
      articleStatus: zod.enum(["Вывод", "Новый", "Неликвид", "Ликвид", "Перезапуск", "Архив"]),
      productCardStatus: zod.enum([
        "Архив",
        "не в АМ",
        "Ключевой",
        "Распродаем",
        "Запуск",
        "СТОП отгрузка!",
        "Перезапуск",
        "Для индексации цен",
        "Стратегия демпинга",
        "FBS",
        "Дешевый выкуп",
      ]),
      companyName: zod.string(),
      brand: zod.string().optional(),
      isFavorite: zod.boolean(),
      orders: zod.array(
        zod.object({
          date: zod.string().describe("Дата заказа"),
          ordersAmount: zod.number().describe("Количество заказов"),
        })
      ),
      manager: zod.object({
        email: zod.string(),
        managerId: zod.string(),
        name: zod.string(),
        surname: zod.string(),
      }),
    })
  ),
});
export const tableControllerGetProductsOrderHistoryResponse = zod.array(
  tableControllerGetProductsOrderHistoryResponseItem
);

/**
 * Получение информации о выручке / прибыли за каждый товар. Товары разбиты по категориям
 */
export const tableControllerGetRevenueQueryParams = zod.object({
  date: zod.any().optional(),
});

export const tableControllerGetRevenueResponseItem = zod.object({
  category: zod.string(),
  products: zod.array(
    zod.object({
      generalArticle: zod.number().describe("Уникальный код товара без привязки к маркетплейсу"),
      id: zod.number().describe("Первичный ключ карточки продукта"),
      sku: zod.number().describe("Уникальный номер товара на маркетплейсе"),
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      category: zod.string().describe("Категория товара"),
      name: zod.string().describe("Название товара"),
      image: zod.string(),
      url: zod.string().describe("Ссылка на карточку товара"),
      mpStatUrl: zod.string(),
      articleStatus: zod.enum(["Вывод", "Новый", "Неликвид", "Ликвид", "Перезапуск", "Архив"]),
      productCardStatus: zod.enum([
        "Архив",
        "не в АМ",
        "Ключевой",
        "Распродаем",
        "Запуск",
        "СТОП отгрузка!",
        "Перезапуск",
        "Для индексации цен",
        "Стратегия демпинга",
        "FBS",
        "Дешевый выкуп",
      ]),
      companyName: zod.string(),
      brand: zod.string().optional(),
      isFavorite: zod.boolean(),
      plannedPrice: zod.number(),
      averagePrice: zod.number(),
      plannedRevenue: zod.number(),
      actualRevenue: zod.number(),
      newDailyRevenuePlan: zod.number(),
      plannedNetProfit: zod.number(),
      actualNetProfit: zod.number(),
      newDailyNetProfitPlan: zod.number(),
      manager: zod.object({
        email: zod.string(),
        managerId: zod.string(),
        name: zod.string(),
        surname: zod.string(),
      }),
    })
  ),
});
export const tableControllerGetRevenueResponse = zod.array(tableControllerGetRevenueResponseItem);

/**
 * @summary Получение данных для выборки
 */
export const marketShareControllerGetOptionsResponse = zod.object({
  marketplaces: zod.array(zod.enum(["OZON", "WB", "YM"])),
  categories: zod.array(zod.string()).describe("Названия всех категорий"),
  orderOptions: zod.array(
    zod
      .enum(["orders", "revenue", "price", "sku_count"])
      .describe(
        "Поле для сортировки. count - по количеству продаж, price - по средней цене, revenue - по общей выручке"
      )
  ),
});

/**
 * Возвращает общую статистики доли рынка по портфелям для выбранных маркетплейсов за период
 * @summary Получение общей статистики доли рынка по портфелям
 */
export const marketShareControllerGetBriefcaseShareStatsQueryParams = zod.object({
  periodStart: zod.string().date().describe("Дата начала периода в формате YYYY-MM-DD"),
  periodEnd: zod.string().date().describe("Дата окончания периода в формате YYYY-MM-DD"),
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe(
      "Площадки для анализа. Если не указано, пустой массив или null - будут использоваться все площадки."
    ),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле выборки"),
});

export const marketShareControllerGetBriefcaseShareStatsResponse = zod.object({
  shareStat: zod.number().describe("Общая статистика выбранного поля по всем портфелям"),
  ourStat: zod.number().describe("Наша статистика выбранного поля по всем портфелям"),
  briefcaseMarketShareStats: zod
    .array(
      zod.object({
        briefcaseName: zod.string().describe("Название портфеля"),
        shareStat: zod.number().describe("Общая статистика выбранного поля по портфелю"),
        ourStat: zod.number().describe("Наша статистика выбранного поля по портфелю"),
        categoriesMarketShareStats: zod
          .array(
            zod.object({
              categoryName: zod.string().describe("Название категории"),
              shareStat: zod.number().describe("Общая Статистика выбранного поля по категории"),
              ourStat: zod.number().describe("Наша Статистика выбранного поля по категории"),
            })
          )
          .describe("Статистика по категориям внутри портфеля"),
      })
    )
    .describe("Статистика по портфелям товаров"),
});

/**
 * Возвращает список брендов по доле рынка по портфелям
 * @summary Список брендов по доле рынка по портфелям
 */
export const marketShareControllerGetBriefcaseBrandListQueryParams = zod.object({
  periodStart: zod.string().date().describe("Дата начала периода в формате YYYY-MM-DD"),
  periodEnd: zod.string().date().describe("Дата окончания периода в формате YYYY-MM-DD"),
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe(
      "Площадки для анализа. Если не указано, пустой массив или null - будут использоваться все площадки."
    ),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле выборки"),
});

export const marketShareControllerGetBriefcaseBrandListResponse = zod.object({
  competitorBrand: zod
    .array(
      zod.object({
        statistic: zod.number().describe("Статистика конкурента по портфелю"),
        position: zod.number().describe("Позиция в топе"),
        brandName: zod.string().describe("Название бренда конкурента"),
      })
    )
    .describe("Статистика брендов"),
});

/**
 * Возвращает списков брендов по доле рынка для конкретных категорий и маркетплейсов за текущий и прошлый период
 * @summary Получение списков брендов по доле рынка по категориям за текущий и прошлый период
 */
export const marketShareControllerGetCategoryBrandListQueryParams = zod.object({
  periodStart: zod.string().date().describe("Дата начала периода в формате YYYY-MM-DD"),
  periodEnd: zod.string().date().describe("Дата окончания периода в формате YYYY-MM-DD"),
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений). Если пусто - будут выбраны все площадки."),
  category: zod.array(zod.string()).nullish().describe("Массив  названий категорий для анализа"),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле сортировки"),
});

export const marketShareControllerGetCategoryBrandListResponse = zod.object({
  brandList: zod
    .array(
      zod.object({
        statistic: zod.number().describe("Статистика конкурента по портфелю за текущий период"),
        previous: zod.number().describe("Статистика конкурента по портфелю за прошедший период"),
        position: zod.number().describe("Позиция в топе"),
        brandName: zod.string().describe("Название бренда конкурента"),
      })
    )
    .describe("Список брендов со статистикой за прошлый период"),
});

/**
 * Возвращает статистику доли по категориям рынка для конкретных категорий и маркетплейсов
 * @summary Получение статистики доли рынка по категориям
 */
export const marketShareControllerGetCategoryShareStatsQueryParams = zod.object({
  periodStart: zod.string().date().describe("Дата начала периода в формате YYYY-MM-DD"),
  periodEnd: zod.string().date().describe("Дата окончания периода в формате YYYY-MM-DD"),
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений). Если пусто - будут выбраны все площадки."),
  category: zod.array(zod.string()).describe("Массив  названий категорий для анализа"),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле выборки"),
});

export const marketShareControllerGetCategoryShareStatsResponse = zod.object({
  categories: zod
    .array(
      zod.object({
        categoryName: zod.string().describe("Название категории"),
        shareStat: zod.number().describe("Общая Статистика выбранного поля по категории"),
        ourStat: zod.number().describe("Наша Статистика выбранного поля по категории"),
      })
    )
    .describe("Статистика по категориям"),
});

/**
 * @summary Расчетные данные по выбранному полю за период по маркетплейсам
 */
export const marketShareControllerGetPeriodValueQueryParams = zod.object({
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений). Если пусто - будут выбраны все площадки."),
  category: zod.array(zod.string()).describe("Массив  названий категорий для анализа"),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле выборки"),
});

export const marketShareControllerGetPeriodValueResponseItem = zod.object({
  date: zod.string().describe("Период расчета"),
  marketplacePeriodData: zod
    .array(
      zod.object({
        marketplace: zod.enum(["OZON", "WB", "YM"]),
        ourValue: zod.number().describe("Расчетные данные наши"),
        commonValue: zod.number().describe("Расчетные данные общие"),
      })
    )
    .describe("Данные за период по маркетплейсам"),
});
export const marketShareControllerGetPeriodValueResponse = zod.array(
  marketShareControllerGetPeriodValueResponseItem
);

/**
 * @summary Данные по ценовым сегментам
 */
export const marketShareControllerGetSegmentQueryParams = zod.object({
  periodStart: zod.string().date().describe("Дата начала периода в формате YYYY-MM-DD"),
  periodEnd: zod.string().date().describe("Дата окончания периода в формате YYYY-MM-DD"),
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений). Если пусто - будут выбраны все площадки."),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле сортировки"),
  category: zod.array(zod.string()).nullish().describe("Массив  названий категорий для анализа"),
});

export const marketShareControllerGetSegmentResponseItem = zod.object({
  priceFrom: zod.number().describe("Нижняя граница ценового сегмента"),
  priceTo: zod.number().describe("Верхняя граница ценового сегмента"),
  value: zod.number().describe("Значение компании"),
  competitorValue: zod.number().describe("Значение конкурента"),
});
export const marketShareControllerGetSegmentResponse = zod.array(
  marketShareControllerGetSegmentResponseItem
);

/**
 * @summary Данные по ценовым сегментам в периоде
 */
export const marketShareControllerGetPeriodSegmentQueryParams = zod.object({
  marketplaces: zod
    .array(zod.enum(["OZON", "WB", "YM"]))
    .optional()
    .describe("Площадки для анализа (массив значений). Если пусто - будут выбраны все площадки."),
  brandOrder: zod.enum(["orders", "revenue", "price", "sku_count"]).describe("Поле сортировки"),
  category: zod.array(zod.string()).nullish().describe("Массив  названий категорий для анализа"),
});

export const marketShareControllerGetPeriodSegmentResponseItem = zod.object({
  date: zod.string().describe("Дата в формате YYYY-MM"),
  segments: zod
    .array(
      zod.object({
        priceFrom: zod.number().describe("Нижняя граница ценового сегмента"),
        priceTo: zod.number().describe("Верхняя граница ценового сегмента"),
        value: zod.number().describe("Значение компании"),
        competitorValue: zod.number().describe("Значение конкурента"),
      })
    )
    .describe("Значение в сегменте разделенное по дате"),
});
export const marketShareControllerGetPeriodSegmentResponse = zod.array(
  marketShareControllerGetPeriodSegmentResponseItem
);

/**
 * @summary Импорт данных о чужих скю за месяц
 */
export const competitorControllerImportCompetitorStatsHeader = zod.object({
  signature: zod.string().optional().describe("Подпись запроса"),
});

export const competitorControllerImportCompetitorStatsBodyDataItemBrandNameDefault =
  "отсутствует_бренд";
export const competitorControllerImportCompetitorStatsBodyDataItemBrandNameMax = 255;
export const competitorControllerImportCompetitorStatsBodyDataItemSubcategoryNameMax = 255;
export const competitorControllerImportCompetitorStatsBodyDataItemRevenueMin = 0;

export const competitorControllerImportCompetitorStatsBodyDataItemRevenueMax = 9999999999999.99;

export const competitorControllerImportCompetitorStatsBody = zod.object({
  data: zod
    .array(
      zod.object({
        brandName: zod
          .string()
          .max(competitorControllerImportCompetitorStatsBodyDataItemBrandNameMax)
          .default(competitorControllerImportCompetitorStatsBodyDataItemBrandNameDefault)
          .describe("Название бренда"),
        sku: zod.number().min(1).describe("SKU товара"),
        subcategoryName: zod
          .string()
          .max(competitorControllerImportCompetitorStatsBodyDataItemSubcategoryNameMax)
          .describe("subcategoryName"),
        marketplace: zod.enum(["OZON", "WB", "YM"]),
        date: zod.string().date().describe("Дата статистики (формат: YYYY-MM-DD)"),
        revenue: zod
          .number()
          .min(competitorControllerImportCompetitorStatsBodyDataItemRevenueMin)
          .max(competitorControllerImportCompetitorStatsBodyDataItemRevenueMax)
          .describe("Выручка"),
        orders: zod.number().min(1).describe("Количество заказов"),
        name: zod.string().describe("Название"),
        seller: zod.string().optional().describe("Продавец"),
        color: zod.string().optional().describe("Цвет"),
        balance: zod.number().optional().describe("Сток - агрегированный за месяц"),
        comments: zod.number().optional().describe("Комментарии - агрегированный за месяц"),
        rating: zod.number().optional().describe("Рейтинг средний за месяц"),
        final_price: zod.number().optional().describe("Финальная цена на момент парсинга"),
        final_price_average: zod.number().optional().describe("Средняя финальная цена за месяц"),
        final_price_median: zod.number().optional().describe("Медианная финальная цена за месяц"),
        basic_sale: zod.number().optional().describe("Базовая скидка на момент парсинга"),
        basic_price: zod.number().optional().describe("Базовая цена на момент парсинга"),
        promo_sale: zod.number().optional().describe("Промо скидка на момент парсинга"),
        client_sale: zod.number().optional().describe("Клиентская скидка на момент парсинга"),
        client_price: zod.number().optional().describe("Клиентская цена на момент парсинга"),
        start_price: zod.number().optional().describe("Стартовая цена на момент парсинга"),
        wallet_price: zod.number().optional().describe("Цена с кошельком - ?"),
        sales_per_day_average: zod.number().optional().describe("Средние продажи в день"),
        percent_from_revenue: zod.number().optional().describe("Процент от выручки в категории"),
        revenue_potential: zod.number().optional().describe("Потенциальная выручка"),
        revenue_average: zod.number().optional().describe("Средняя выручка"),
        lost_profit: zod.number().optional().describe("Упущенная прибыль"),
        lost_profit_percent: zod.number().optional().describe("Процент упущенной прибыли"),
        days_in_stock: zod.number().optional().describe("Дней в наличии"),
        days_with_sales: zod.number().optional().describe("Дней с продажами"),
        average_if_in_stock: zod.number().optional().describe("Среднее при наличии"),
        subject: zod.string().optional().describe("Предмет"),
        sku_first_date: zod.string().optional().describe("Первая дата SKU на сайте"),
        firstcommentdate: zod.string().optional().describe("Дата первого комментария на сайте"),
        category_position: zod.string().optional().describe("Позиция в категории"),
        url: zod.string().optional().describe("URL ссылка на товар"),
        turnover_days: zod.number().optional().describe("Дни оборачиваемости"),
        frozen_stocks: zod.number().optional().describe("Замороженные остатки"),
        frozen_stocks_cost: zod.number().optional().describe("Стоимость замороженных остатков"),
        frozen_stocks_percent: zod.number().optional().describe("Процент замороженных остатков"),
        related_products_count: zod.number().optional().describe("Количество похожих продуктов"),
        related_products_in_stock_count: zod
          .number()
          .optional()
          .describe("Количество похожих продуктов в наличии"),
        search_cpm_avg: zod.number().optional().describe("Средний CPM в поиске"),
        search_ad_position_avg: zod
          .number()
          .optional()
          .describe("Средняя позиция рекламы в поиске"),
        search_organic_position_avg: zod
          .number()
          .optional()
          .describe("Средняя органическая позиция в поиске"),
        package_length: zod.number().optional().describe("Длина упаковки"),
        package_width: zod.number().optional().describe("Ширина упаковки"),
        package_height: zod.number().optional().describe("Высота упаковки"),
      })
    )
    .describe("Массив данных статистики конкурентов"),
});

export const competitorControllerImportCompetitorStatsResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Получить SKU без статистики за период
 */
export const competitorControllerGetSkusWithoutStatsQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetSkusWithoutStatsQueryParams = zod.object({
  date: zod
    .string()
    .regex(competitorControllerGetSkusWithoutStatsQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetSkusWithoutStatsResponseItem = zod.object({
  competitor_sku: zod.number().describe("SKU конкурента"),
  subcategoryName: zod.string().describe("Название категории"),
  productGroupName: zod.string().describe("Товарная группа"),
  parentCategoryName: zod.string().describe("Родительская категория"),
  category_id: zod.number().describe("ID категории"),
});
export const competitorControllerGetSkusWithoutStatsResponse = zod.array(
  competitorControllerGetSkusWithoutStatsResponseItem
);

/**
 * @summary Отстутствующие скю за период
 */
export const competitorControllerGetLostQueryDateRegExp = new RegExp("^\\d{4}-\\d{2}(-\\d{2})?$");

export const competitorControllerGetLostQueryParams = zod.object({
  date: zod
    .string()
    .regex(competitorControllerGetLostQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetLostResponseItem = zod.object({
  competitor_sku: zod.number().describe("SKU конкурента"),
  subcategoryName: zod.string().describe("Название категории"),
  productGroupName: zod.string().describe("Товарная группа"),
  parentCategoryName: zod.string().describe("Родительская категория"),
  category_id: zod.number().describe("ID категории"),
});
export const competitorControllerGetLostResponse = zod.array(
  competitorControllerGetLostResponseItem
);

/**
 * @summary Ручное создание конкуренции
 */
export const competitorControllerCreateManualCompetitorParams = zod.object({
  sku: zod.number(),
});

export const competitorControllerCreateManualCompetitorBody = zod.object({
  competitorSku: zod.number().describe("SKU конкурента"),
});

export const competitorControllerCreateManualCompetitorResponse = zod.object({
  sku: zod.number().describe("SKU наша"),
  competitorSku: zod.number().describe("SKU конкурента"),
  isMarked: zod.boolean().describe("Отображение пометки связи"),
});

/**
 * @summary Пометка конкуренции
 */
export const competitorControllerMarkParams = zod.object({
  sku: zod.number(),
});

export const competitorControllerMarkQueryParams = zod.object({
  competitor: zod.number(),
});

export const competitorControllerMarkBodyDateRegExp = new RegExp("^\\d{4}-\\d{2}(-\\d{2})?$");

export const competitorControllerMarkBody = zod.object({
  isMarked: zod.boolean().describe("Пометить (true) или убрать метку (false)"),
  date: zod
    .string()
    .regex(competitorControllerMarkBodyDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerMarkResponse = zod.object({
  sku: zod.number().describe("Наш SKU"),
  competitorSku: zod.number().describe("SKU конкурента"),
  isMarked: zod.boolean().describe("Помечена ли связь"),
});

/**
 * @summary Поиск SKU конкурентов
 */
export const competitorControllerSearchSkuQueryParams = zod.object({
  sku: zod.number().describe("SKU для поиска (4-15 цифр)"),
});

export const competitorControllerSearchSkuResponseItem = zod.object({
  competitorSku: zod.number().describe("SKU конкурента"),
  name: zod.string().optional().describe("Имя SKU конкурента"),
  brand: zod.string().describe("Имя Бренда конкурента"),
});
export const competitorControllerSearchSkuResponse = zod.array(
  competitorControllerSearchSkuResponseItem
);

/**
 * @summary Импорт данных связанных скю за неделю
 */
export const competitorControllerImportCompetitorRelationHeader = zod.object({
  signature: zod.string().optional().describe("Подпись запроса"),
});

export const competitorControllerImportCompetitorRelationBodyDataItemOurSkuMin = 0;
export const competitorControllerImportCompetitorRelationBodyDataItemCompetitorSkuMin = 0;

export const competitorControllerImportCompetitorRelationBody = zod.object({
  data: zod
    .array(
      zod.object({
        ourSku: zod
          .number()
          .min(competitorControllerImportCompetitorRelationBodyDataItemOurSkuMin)
          .describe("SKU товара"),
        competitorSku: zod
          .number()
          .min(competitorControllerImportCompetitorRelationBodyDataItemCompetitorSkuMin)
          .describe("SKU конкурента"),
        explanation: zod
          .string()
          .min(1)
          .describe(
            "Вывод модели если эту связь была предложена моделью. Если это не выбор модели поле должно быть null"
          ),
        greatFeature: zod
          .string()
          .min(1)
          .describe("Сравнения, сравнения. Если ручной ввод, тогда поле не вводится"),
        date: zod.string().describe("Время формирования вывода. Формат YYYY-MM-DD"),
      })
    )
    .describe("массив связей конкурентов"),
});

export const competitorControllerImportCompetitorRelationResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Получить статистику по категориям
 */
export const competitorControllerGetCategoryStatQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetCategoryStatQueryParams = zod.object({
  categoryIds: zod.array(zod.number()).describe("Массив ID категорий"),
  date: zod
    .string()
    .regex(competitorControllerGetCategoryStatQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetCategoryStatResponseItem = zod.object({
  categoryId: zod.number().describe("ID категории"),
  categoryName: zod.string().describe("Название категории"),
  articles: zod
    .array(
      zod.object({
        sku: zod.number().describe("SKU товара"),
        articleName: zod.string().describe("Название товара"),
        article: zod.number().describe("Номер артикля"),
        imageLink: zod.string().describe("ссылка на изображение"),
        briefcase: zod.string().describe("Название портфеля"),
        mpStatLink: zod.string().describe("ссылка на  мпстат"),
        marketplaceLink: zod.string().describe("ссылка в маркетплейсе"),
        competitorCount: zod.number().describe("Количество конкурентов"),
        competitorRevenue: zod.number().describe("Выручка конкурентов"),
        competitorOrdersCount: zod.number().describe("Количество заказов конкурентов"),
        competitorAvgPrice: zod.number().describe("Средняя цена конкурентов"),
        competitorAvgRating: zod.number().describe("Средний рейтинг конкурентов"),
        competitorReviewCount: zod.number().describe("Количество отзывов конкурентов"),
        revenue: zod.number().describe("Выручка"),
        ordersCount: zod.number().describe("Количество заказов"),
      })
    )
    .describe("Список товаров"),
});
export const competitorControllerGetCategoryStatResponse = zod.array(
  competitorControllerGetCategoryStatResponseItem
);

/**
 * @summary Получить общую статистику по портфелям
 */
export const competitorControllerGetBriefcaseStatQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetBriefcaseStatQueryParams = zod.object({
  categoryIds: zod.array(zod.number()).describe("Массив ID категорий"),
  date: zod
    .string()
    .regex(competitorControllerGetBriefcaseStatQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetBriefcaseStatResponse = zod.object({
  competitorCount: zod.number().describe("Количество конкурентов"),
  competitorAvgRating: zod.number().describe("Средний рейтинг конкурентов"),
  brandCount: zod.number().describe("Количество брендов"),
});

/**
 * @summary Получить помесячную статистику по категориям зв пол года
 */
export const competitorControllerGetMonthlyStatsQueryParams = zod.object({
  categoryIds: zod.array(zod.number()).describe("Массив ID категорий"),
});

export const competitorControllerGetMonthlyStatsResponseItem = zod.object({
  month: zod.string().describe("Месяц в формате YYYY-MM"),
  revenue: zod.number().describe("Наша выручка"),
  orderCount: zod.number().describe("Количество наших заказов"),
  competitorRevenue: zod.number().describe("Выручка конкурентов"),
  competitorOrderCount: zod.number().describe("Количество заказов конкурентов"),
});
export const competitorControllerGetMonthlyStatsResponse = zod.array(
  competitorControllerGetMonthlyStatsResponseItem
);

/**
 * @summary Получить конкурентов по скю
 */
export const competitorControllerGetCompetitorListParams = zod.object({
  sku: zod.number(),
});

export const competitorControllerGetCompetitorListQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetCompetitorListQueryParams = zod.object({
  date: zod
    .string()
    .regex(competitorControllerGetCompetitorListQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetCompetitorListResponseItem = zod.object({
  sku: zod.number().describe("SKU конкурента"),
  productName: zod.string().optional().describe("Название товара конкурента"),
  url: zod.string().optional().describe("URL конкурента"),
  brand: zod.string().describe("Имя бренда конкурента"),
  MPLink: zod.string().describe("ссылка на конкурента на ВБ"),
  legalName: zod.string().optional().describe("Продавец"),
  revenue: zod.number().describe("Выручка конкурента"),
  categoryPercent: zod.number().describe("Процент от выручки в категории"),
  orderCount: zod.number().describe("Количество заказов в штуках у конкурентов"),
  avgPrice: zod.number().describe("Средний чек конкурентов (расчетный)"),
  rating: zod.number().describe("Рейтинг конкурентов"),
  reviewCount: zod.number().describe("Количество отзывов конкурентов"),
  daysInStock: zod.number().describe("Дней в наличии у конкурентов"),
  categoryPosition: zod.number().describe("Позиция конкурента в категории"),
  avgAdPosition: zod.number().describe("Средняя позиция рекламы в поиске у конкурентов"),
  avgOrganicPosition: zod.number().describe("Средняя органическая позиция в поиске у конкурентов"),
  isMarked: zod.boolean().describe("Отображение пометки связи"),
});
export const competitorControllerGetCompetitorListResponse = zod.array(
  competitorControllerGetCompetitorListResponseItem
);

/**
 * @summary Получить детальную статистику по связи с конкурентом
 */
export const competitorControllerGetCompetitorRelationParams = zod.object({
  sku: zod.number(),
  competitor: zod.number(),
});

export const competitorControllerGetCompetitorRelationQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetCompetitorRelationQueryParams = zod.object({
  date: zod
    .string()
    .regex(competitorControllerGetCompetitorRelationQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetCompetitorRelationResponse = zod.object({
  explanation: zod.string().describe("Вывод который сделала МЛ"),
  greatFeatures: zod.string().nullish().describe("Главное отличие конкурента"),
  isMarked: zod.boolean().describe("Маркирует помеченные связи"),
  color: zod.string().nullish().describe("Цвет товара"),
  balance: zod.number().nullish().describe("сток за месяц"),
  comments: zod.number().nullish().describe("Комментарии за месяц"),
  rating: zod.number().nullish().describe("Средний рейтинг за месяц"),
  final_price: zod.number().nullish().describe("Финальная цена"),
  final_price_average: zod.number().nullish().describe("Средняя финальная цена за месяц"),
  final_price_median: zod.number().nullish().describe("Медианная финальная цена за месяц"),
  basic_sale: zod.number().nullish().describe("Базовая скидка"),
  basic_price: zod.number().nullish().describe("Базовая цена"),
  promo_sale: zod.number().nullish().describe("Промо скидка"),
  client_sale: zod.number().nullish().describe("Клиентская скидка"),
  client_price: zod.number().nullish().describe("Клиентская цена"),
  start_price: zod.number().nullish().describe("Стартовая цена"),
  wallet_price: zod.number().nullish().describe("Цена с кошельком"),
  sales_per_day_average: zod.number().nullish().describe("Средние продажи в день"),
  revenue_potential: zod.number().nullish().describe("Потенциальная выручка"),
  revenue_average: zod.number().nullish().describe("Средняя выручка"),
  lost_profit: zod.number().nullish().describe("Упущенная прибыль"),
  lost_profit_percent: zod.number().nullish().describe("Процент упущенной прибыли"),
  days_with_sales: zod.number().nullish().describe("Дней с продажами"),
  average_if_in_stock: zod.number().nullish().describe("Среднее при наличии"),
  subject: zod.string().nullish(),
  sku_first_date: zod.string().nullish().describe("Первая дата SKU на сайте"),
  firstcommentdate: zod.string().nullish().describe("Дата первого комментария на сайте"),
  category: zod.string().nullish(),
  turnover_days: zod.number().nullish().describe("Дни оборачиваемости"),
  frozen_stocks: zod.number().nullish().describe("Замороженные остатки "),
  frozen_stocks_cost: zod.number().nullish().describe("Стоимость замороженных остатков"),
  frozen_stocks_percent: zod.number().nullish().describe("Процент замороженных остатков"),
  related_products_count: zod.number().nullish().describe("Количество похожих продуктов"),
  related_products_in_stock_count: zod
    .number()
    .nullish()
    .describe("Количество похожих продуктов в наличии"),
  search_cpm_avg: zod.number().nullish().describe(" Средний CPM в поиске"),
  search_ad_position_avg: zod.number().nullish().describe("Средняя позиция рекламы в поиске"),
  search_organic_position_avg: zod
    .number()
    .nullish()
    .describe(" Средняя органическая позиция в поиске"),
  package_length: zod.number().nullish(),
  package_width: zod.number().nullish(),
  package_height: zod.number().nullish(),
  competitorSku: zod.number(),
  name: zod.string().nullish(),
  brand: zod.string(),
  url: zod.string().nullish(),
  seller: zod.string().nullish(),
  category_position: zod.number().nullish().describe("Позиция в категории"),
  revenue: zod.number(),
  orders: zod.number().describe("Количество продаже"),
  revenue_share: zod.number().describe("Доля выручки в категории"),
  avg_price: zod.number().describe("Средняя цена"),
});

/**
 * @summary Получить статистику доли по артиклю за пол года
 */
export const competitorControllerGetArticleMonthlyStatParams = zod.object({
  sku: zod.number(),
});

export const competitorControllerGetArticleMonthlyStatResponseItem = zod.object({
  month: zod.string().describe("Месяц в формате YYYY-MM"),
  revenuePercent: zod.number().describe("Процент доли выручки"),
  orderCountPercent: zod.number().describe("Процент доли по количеству продаж"),
  competitorAvgPrice: zod.number().describe("Средняя цена конкурентов"),
  avgPrice: zod.number().describe("Средняя цена"),
});
export const competitorControllerGetArticleMonthlyStatResponse = zod.array(
  competitorControllerGetArticleMonthlyStatResponseItem
);

/**
 * @summary Получить статистику по sku
 */
export const competitorControllerGetSkuStatParams = zod.object({
  sku: zod.number(),
});

export const competitorControllerGetSkuStatQueryDateRegExp = new RegExp(
  "^\\d{4}-\\d{2}(-\\d{2})?$"
);

export const competitorControllerGetSkuStatQueryParams = zod.object({
  date: zod
    .string()
    .regex(competitorControllerGetSkuStatQueryDateRegExp)
    .describe("Дата в формате YYYY-MM-DD или YYYY-MM"),
});

export const competitorControllerGetSkuStatResponse = zod.object({
  sku: zod.number().describe("SKU товара"),
  articleName: zod.string().describe("Название товара"),
  description: zod.string().optional().describe("ссылка на изображение"),
  imageLink: zod.string().describe("URL изображения"),
  mpStatLink: zod.string().describe("ссылка на  мпстат"),
  marketplaceLink: zod.string().describe("ссылка в маркетплейсе"),
  competitorCount: zod.number().describe("Количество конкурентов"),
  competitorBrandsCount: zod.number().describe("Количество брендов конкурентов"),
  competitorAvgRating: zod.number().describe("Средний рейтинг конкурентов"),
  revenue: zod.number().describe("Выручка"),
  revenueShare: zod.number().describe("Доля по выручке (%)"),
  orderCount: zod.number().describe("Количество заказов в штуках"),
  orderShare: zod.number().describe("Доля в штуках (%)"),
});

/**
 * @summary Импорт дневного финреза
 */
export const finrezControllerImportFinrezDailyHeader = zod.object({
  signature: zod.string().optional().describe("Подпись запроса"),
});

export const finrezControllerImportFinrezDailyBody = zod.object({
  data: zod
    .array(
      zod.object({
        date: zod.string().describe("Дата отчёта. Формат YYYY-MM-DD"),
        monthDate: zod.string().describe("Дата начала месяца. Формат YYYY-MM-DD"),
        yearMonth: zod.string().describe("Год-месяц. Формат YYYY-MM"),
        generalArticle: zod.string().describe("Артикул товара (1С)"),
        marketplace: zod.enum(["OZON", "WB", "YM"]).describe("Маркетплейс"),
        name: zod.string().describe("Наименование товара"),
        category: zod.string().describe("Категория товара"),
        briefcase: zod.string().describe("Портфель / товарное направление"),
        categoryGroup: zod.string().describe("Группа категории"),
        categoryGroupAll: zod.string().describe("Общая группа категорий"),
        revenueForOurPrice: zod.number().describe("Выручка по нашей цене"),
        qtyForPrice: zod.number().describe("Количество для расчёта нашей цены"),
        qty: zod.number().describe("Чистое количество"),
        ourPrice: zod.number().describe("Наша цена"),
        revenue: zod.number().describe("Чистая выручка"),
        spp: zod.number().describe("СПП"),
        costPrice: zod.number().describe("Себестоимость"),
        commission: zod.number().describe("Комиссия маркетплейса"),
        acquiring: zod.number().describe("Эквайринг"),
        advert: zod.number().describe("Рекламные расходы"),
        logistics: zod.number().describe("Логистика"),
        otherExpenses: zod.number().describe("Прочие расходы"),
        cm: zod.number().describe("Contribution Margin"),
        totalExpenses: zod.number().describe("Сумма всех расходов"),
        cmPercent: zod.number().describe("Рентабельность по CM"),
        drr: zod.number().describe("Доля рекламных расходов"),
        commissionPercent: zod.number().describe("Доля комиссии"),
        logisticsPercent: zod.number().describe("Доля логистики"),
      })
    )
    .describe("Массив записей финрез daily"),
});

export const finrezControllerImportFinrezDailyResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Получение доступных периодов и маркетплейсов
 */
export const salesChannelControllerGetOptionsResponse = zod.object({
  periods: zod.array(
    zod.object({
      type: zod.enum(["week", "month"]),
      title: zod.string(),
      isDefault: zod.boolean(),
      isAvailable: zod.boolean(),
      period: zod.object({
        type: zod.enum(["week", "month"]),
        from: zod.string().date(),
        to: zod.string().date(),
        previousFrom: zod.string().date(),
        previousTo: zod.string().date(),
        daysCount: zod.number(),
      }),
    })
  ),
  marketplaces: zod.array(
    zod.object({
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      title: zod.string(),
      order: zod.number(),
    })
  ),
  dataFrom: zod.string().date().nullable(),
  dataTo: zod.string().date().nullable(),
});

/**
 * series: 6 метрик × (TOTAL + каналы из данных) × 2 периода. При каналах WB и OZON — 36 серий.
 * @summary Главная страница аналитики по каналам продаж
 */
export const salesChannelControllerGetOverviewQueryParams = zod.object({
  period: zod.enum(["week", "month"]),
});

export const salesChannelControllerGetOverviewResponse = zod.object({
  period: zod.object({
    type: zod.enum(["week", "month"]),
    from: zod.string().date(),
    to: zod.string().date(),
    previousFrom: zod.string().date(),
    previousTo: zod.string().date(),
    daysCount: zod.number(),
  }),
  total: zod.object({
    sales: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    cm: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    cmPercent: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    avgCheck: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    drr: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    qty: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    advert: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
  }),
  channels: zod.array(
    zod.object({
      marketplace: zod.enum(["OZON", "WB", "YM"]),
      title: zod.string(),
      metrics: zod.object({
        sales: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        cm: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        cmPercent: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        avgCheck: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        drr: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        qty: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
        advert: zod.object({
          key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          deltaRelative: zod.number().nullable(),
          trend: zod.enum(["up", "down", "flat"]),
          severity: zod.enum(["ok", "warning", "critical"]),
        }),
      }),
      salesShare: zod.number(),
      status: zod.enum(["ok", "warning", "critical"]),
      deviationsCount: zod.number(),
      economics: zod.object({
        sales: zod.number(),
        items: zod.array(
          zod.object({
            key: zod.enum(["costPrice", "advert", "logistics", "commission", "acquiring", "other"]),
            title: zod.string(),
            amount: zod.number(),
            shareOfSales: zod.number(),
            previousShareOfSales: zod.number().nullable(),
            deltaPoint: zod.number().nullable(),
            severity: zod.enum(["ok", "warning", "critical"]),
          })
        ),
        cm: zod.number(),
        cmPercent: zod.number(),
        previousCmPercent: zod.number().nullable(),
      }),
      deviations: zod.array(
        zod.object({
          priority: zod.number(),
          metric: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
          title: zod.string(),
          unit: zod.enum(["rub", "percent", "pieces"]),
          value: zod.number(),
          previousValue: zod.number().nullable(),
          delta: zod.number().nullable(),
          deltaUnit: zod.enum(["absolute", "percent", "pp"]),
          severity: zod.enum(["ok", "warning", "critical"]),
          ruleCode: zod.string().nullable(),
        })
      ),
    })
  ),
  series: zod.array(
    zod.object({
      metric: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      channel: zod.enum(["TOTAL", "WB", "OZON", "YM"]),
      isPrevious: zod.boolean(),
      min: zod.number(),
      max: zod.number(),
      points: zod.array(
        zod.object({
          date: zod.string().date(),
          value: zod.number().nullable(),
        })
      ),
    })
  ),
  table: zod.object({
    total: zod.object({
      sales: zod.number(),
      cm: zod.number(),
      cmPercent: zod.number(),
      avgCheck: zod.number(),
      drr: zod.number(),
      qty: zod.number(),
      advert: zod.number(),
      severity: zod.object({
        sales: zod.enum(["ok", "warning", "critical"]),
        cm: zod.enum(["ok", "warning", "critical"]),
        cmPercent: zod.enum(["ok", "warning", "critical"]),
        avgCheck: zod.enum(["ok", "warning", "critical"]),
        drr: zod.enum(["ok", "warning", "critical"]),
        qty: zod.enum(["ok", "warning", "critical"]),
        advert: zod.enum(["ok", "warning", "critical"]),
      }),
    }),
    rows: zod.array(
      zod.object({
        marketplace: zod.enum(["OZON", "WB", "YM"]),
        title: zod.string(),
        current: zod.object({
          sales: zod.number(),
          cm: zod.number(),
          cmPercent: zod.number(),
          avgCheck: zod.number(),
          drr: zod.number(),
          qty: zod.number(),
          advert: zod.number(),
          severity: zod.object({
            sales: zod.enum(["ok", "warning", "critical"]),
            cm: zod.enum(["ok", "warning", "critical"]),
            cmPercent: zod.enum(["ok", "warning", "critical"]),
            avgCheck: zod.enum(["ok", "warning", "critical"]),
            drr: zod.enum(["ok", "warning", "critical"]),
            qty: zod.enum(["ok", "warning", "critical"]),
            advert: zod.enum(["ok", "warning", "critical"]),
          }),
        }),
        previous: zod
          .object({
            sales: zod.number(),
            cm: zod.number(),
            cmPercent: zod.number(),
            avgCheck: zod.number(),
            drr: zod.number(),
            qty: zod.number(),
            advert: zod.number(),
            severity: zod.object({
              sales: zod.enum(["ok", "warning", "critical"]),
              cm: zod.enum(["ok", "warning", "critical"]),
              cmPercent: zod.enum(["ok", "warning", "critical"]),
              avgCheck: zod.enum(["ok", "warning", "critical"]),
              drr: zod.enum(["ok", "warning", "critical"]),
              qty: zod.enum(["ok", "warning", "critical"]),
              advert: zod.enum(["ok", "warning", "critical"]),
            }),
          })
          .nullable(),
        days: zod.array(
          zod.object({
            sales: zod.number(),
            cm: zod.number(),
            cmPercent: zod.number(),
            avgCheck: zod.number(),
            drr: zod.number(),
            qty: zod.number(),
            advert: zod.number(),
            severity: zod.object({
              sales: zod.enum(["ok", "warning", "critical"]),
              cm: zod.enum(["ok", "warning", "critical"]),
              cmPercent: zod.enum(["ok", "warning", "critical"]),
              avgCheck: zod.enum(["ok", "warning", "critical"]),
              drr: zod.enum(["ok", "warning", "critical"]),
              qty: zod.enum(["ok", "warning", "critical"]),
              advert: zod.enum(["ok", "warning", "critical"]),
            }),
            date: zod.string().date(),
          })
        ),
      })
    ),
  }),
  targets: zod.array(
    zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      scope: zod.enum(["TOTAL", "WB", "OZON", "YM"]),
      value: zod.number(),
    })
  ),
});

/**
 * @summary Детальная страница по каналу продаж
 */
export const salesChannelControllerGetMarketplaceDetailParams = zod.object({
  marketplace: zod.enum(["OZON", "WB", "YM"]),
});

export const salesChannelControllerGetMarketplaceDetailQueryParams = zod.object({
  period: zod.enum(["week", "month"]),
});

export const salesChannelControllerGetMarketplaceDetailResponse = zod.object({
  period: zod.object({
    type: zod.enum(["week", "month"]),
    from: zod.string().date(),
    to: zod.string().date(),
    previousFrom: zod.string().date(),
    previousTo: zod.string().date(),
    daysCount: zod.number(),
  }),
  marketplace: zod.enum(["OZON", "WB", "YM"]),
  title: zod.string(),
  metrics: zod.object({
    sales: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    cm: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    cmPercent: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    avgCheck: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    drr: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    qty: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    advert: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
  }),
  series: zod.array(
    zod.object({
      metric: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      channel: zod.enum(["TOTAL", "WB", "OZON", "YM"]),
      isPrevious: zod.boolean(),
      min: zod.number(),
      max: zod.number(),
      points: zod.array(
        zod.object({
          date: zod.string().date(),
          value: zod.number().nullable(),
        })
      ),
    })
  ),
  cmSeries: zod.array(
    zod.object({
      metric: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      channel: zod.enum(["TOTAL", "WB", "OZON", "YM"]),
      isPrevious: zod.boolean(),
      min: zod.number(),
      max: zod.number(),
      points: zod.array(
        zod.object({
          date: zod.string().date(),
          value: zod.number().nullable(),
        })
      ),
    })
  ),
  economics: zod.object({
    sales: zod.number(),
    items: zod.array(
      zod.object({
        key: zod.enum(["costPrice", "advert", "logistics", "commission", "acquiring", "other"]),
        title: zod.string(),
        amount: zod.number(),
        shareOfSales: zod.number(),
        previousShareOfSales: zod.number().nullable(),
        deltaPoint: zod.number().nullable(),
        severity: zod.enum(["ok", "warning", "critical"]),
      })
    ),
    cm: zod.number(),
    cmPercent: zod.number(),
    previousCmPercent: zod.number().nullable(),
  }),
  spp: zod.object({
    average: zod.object({
      key: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      value: zod.number(),
      previousValue: zod.number().nullable(),
      delta: zod.number().nullable(),
      deltaUnit: zod.enum(["absolute", "percent", "pp"]),
      deltaRelative: zod.number().nullable(),
      trend: zod.enum(["up", "down", "flat"]),
      severity: zod.enum(["ok", "warning", "critical"]),
    }),
    series: zod.object({
      metric: zod.enum(["sales", "cm", "cmPercent", "avgCheck", "drr", "qty", "advert", "spp"]),
      unit: zod.enum(["rub", "percent", "pieces"]),
      channel: zod.enum(["TOTAL", "WB", "OZON", "YM"]),
      isPrevious: zod.boolean(),
      min: zod.number(),
      max: zod.number(),
      points: zod.array(
        zod.object({
          date: zod.string().date(),
          value: zod.number().nullable(),
        })
      ),
    }),
  }),
  days: zod.array(
    zod.object({
      date: zod.string().date().nullable().describe("null — итоговая строка без даты"),
      sales: zod.number(),
      qty: zod.number(),
      avgCheck: zod.number(),
      advert: zod.number(),
      drr: zod.number(),
      cm: zod.number(),
      cmPercent: zod.number(),
      spp: zod.number(),
      severity: zod.object({
        sales: zod.enum(["ok", "warning", "critical"]),
        qty: zod.enum(["ok", "warning", "critical"]),
        avgCheck: zod.enum(["ok", "warning", "critical"]),
        advert: zod.enum(["ok", "warning", "critical"]),
        drr: zod.enum(["ok", "warning", "critical"]),
        cm: zod.enum(["ok", "warning", "critical"]),
        cmPercent: zod.enum(["ok", "warning", "critical"]),
        spp: zod.enum(["ok", "warning", "critical"]),
      }),
    })
  ),
  total: zod.object({
    date: zod.string().date().nullable().describe("null — итоговая строка без даты"),
    sales: zod.number(),
    qty: zod.number(),
    avgCheck: zod.number(),
    advert: zod.number(),
    drr: zod.number(),
    cm: zod.number(),
    cmPercent: zod.number(),
    spp: zod.number(),
    severity: zod.object({
      sales: zod.enum(["ok", "warning", "critical"]),
      qty: zod.enum(["ok", "warning", "critical"]),
      avgCheck: zod.enum(["ok", "warning", "critical"]),
      advert: zod.enum(["ok", "warning", "critical"]),
      drr: zod.enum(["ok", "warning", "critical"]),
      cm: zod.enum(["ok", "warning", "critical"]),
      cmPercent: zod.enum(["ok", "warning", "critical"]),
      spp: zod.enum(["ok", "warning", "critical"]),
    }),
  }),
  previousTotal: zod
    .object({
      date: zod.string().date().nullable().describe("null — итоговая строка без даты"),
      sales: zod.number(),
      qty: zod.number(),
      avgCheck: zod.number(),
      advert: zod.number(),
      drr: zod.number(),
      cm: zod.number(),
      cmPercent: zod.number(),
      spp: zod.number(),
      severity: zod.object({
        sales: zod.enum(["ok", "warning", "critical"]),
        qty: zod.enum(["ok", "warning", "critical"]),
        avgCheck: zod.enum(["ok", "warning", "critical"]),
        advert: zod.enum(["ok", "warning", "critical"]),
        drr: zod.enum(["ok", "warning", "critical"]),
        cm: zod.enum(["ok", "warning", "critical"]),
        cmPercent: zod.enum(["ok", "warning", "critical"]),
        spp: zod.enum(["ok", "warning", "critical"]),
      }),
    })
    .nullable(),
});
